// extracted by mini-css-extract-plugin
export default {"mandatory":"StepTwo_mandatory__4XbHm"};